import ApiService from "vamos/cockpit/base/services/type/ApiService";
import { ResponseStatusMessage, StatusMessage } from "vamos/cockpit/model/api/vamos.private.api.types";
import { showStatusMessage } from "vamos/cockpit/base/handler/MessageToastHandler";

/**
 * @namespace vamos.cockpit.data.request.service
 */
export default class TypedRequestService {
    public static async extractRequest(payload: object): Promise<StatusMessage> {
        const response = await ApiService.getInstance().postRestJsonData<ResponseStatusMessage>("/request/extract-requests", payload);
        showStatusMessage(response.data.content)
        return response.data.content;
    }
}